import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

export default function Chart(data) {
  return (
    <React.Fragment>
      <ResponsiveContainer height="100%">
        <LineChart
          height={500}
          width={800}
          data={data.data}
          margin={{
            top: 20,
            right: 5,
            bottom: 15,
            left: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />

          <XAxis dataKey="Timestamp" width={75} 
          tick={{ width: 75 }}/>
          
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="Value" dot={false} name="value" key="value"/>
        </LineChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
}
